<template>
  <b-container style="margin-top:90px;" fluid >
        <video-player :options="videoOptions" class="mx-auto" />
  </b-container>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer.vue";

export default {
  name: "VideoExample",
  components: {
    VideoPlayer
  },
  props: ["videofile"],
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [
          {
            src: atob(this.videofile.replace("_", "/").replace("-", "+")),
            type: "video/mp4"
          }
        ]
      }
    };
  }
};
</script>
<style scoped>
</style>